import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringify',
    standalone: true,
})
export class StringifyPipe implements PipeTransform {
    public transform(value: unknown): string {
        if (!value) {
            return '';
        }

        if (Array.isArray(value)) {
            return value.toString();
        }

        if (typeof value === 'object') {
            return JSON.stringify(value);
        }

        return String(value);
    }
}
